import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Heading, Icon, Stack, Text } from "@chakra-ui/react";

import { RoutesMap } from "../../../../routes";
import { ErrorTechInfo } from "./ErrorTechInfo";
import { IErrorComponent } from "../ErrorComponent";

interface Props extends IErrorComponent {
  icon: FC;
  header?: string;
  message: string;
  additionalMessage?: string;
  showTechInfo?: boolean;
  showReloadButton?: boolean;
}

export const ErrorTemplate: FC<Props> = (props) => {
  const {
    error,
    icon,
    header = "Что-то пошло не так",
    message,
    additionalMessage = "",
    showTechInfo = false,
    techInfoBgColor,
    showReloadButton = true,
    showGoHomeButton = true,
    refetch,
  } = props;

  const navigate = useNavigate();
  const reloadButtonColorSchema = showGoHomeButton ? "purple" : "brand";

  const onReload = async () => {
    if (refetch) {
      await refetch();
      return;
    }

    window.location.reload();
  };

  const onGoHome = () => {
    navigate(RoutesMap.index);
  };

  return (
    <Stack mt="20px" alignItems="center">
      <Stack w="100%" maxW="300px" spacing={0} alignItems="center">
        <Icon as={icon} boxSize="80px" />
        <Heading mt="8px" mb="8px">{header}</Heading>

        <Text textAlign="center">{message}</Text>
        <Text mt="10px" textAlign="center">{additionalMessage}</Text>

        {showTechInfo && <ErrorTechInfo error={error} bgColor={techInfoBgColor} />}

        <Stack w="100%" mt="24px" spacing="6px">
          {showReloadButton && (
            <Button colorScheme={reloadButtonColorSchema} onClick={onReload}>
              Обновить
            </Button>
          )}

          {showGoHomeButton && (
            <Button colorScheme="brand" onClick={onGoHome}>
              На главную
            </Button>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};
